import { render, staticRenderFns } from "./MatchChat.vue?vue&type=template&id=31e2eb71&"
import script from "./MatchChat.vue?vue&type=script&lang=js&"
export * from "./MatchChat.vue?vue&type=script&lang=js&"
import style0 from "./MatchChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports